import type { FunctionComponent } from "react"

import { NewsFeedWrapper } from "@/features/companyDetail/components/NewsFeed/NewsFeedWrapper/NewsFeedWrapper"

type NewsfeedProps = {
  timeZone: Intl.ResolvedDateTimeFormatOptions["timeZone"]
}
export const Newsfeed: FunctionComponent<NewsfeedProps> = props => {
  const { timeZone } = props
  return (
    <div data-testid="company_news_feed">
      <NewsFeedWrapper timeZone={timeZone} />
    </div>
  )
}
